import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue'

export const pravicePredelavaService = {
    load,save
    
};

function load(sezona) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelovalec/pravice?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(pravicePredelava => {
            // login successful if there's a jwt token in the response
            
            return pravicePredelava;
        }).
        catch(error=>{
            console.log(error)
        });
}

function save(pravicePredelava) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(pravicePredelava)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelovalec/pravice`, requestOptions).then(handleResponse);
}


